import React, { Component } from "react";
import styled from "styled-components";
import Product from "../components/CategoryProducts/Product";
import LoadingSpinner from "../components/LoadingSpinner";
import { Query } from "@apollo/client/react/components";
import ProductsQuery from "../apollo/queries/ProductsQuery";
import Error from "../components/Error";
import { withRouter } from "../withRouter";

const Container = styled.main`
  max-width: 1200px;
  margin: 3rem auto;
  position: relative;
  min-height: 100vh;
`;
const ProductsContainer = styled.div`
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  column-gap: 50px;
  row-gap: 120px;
  text-align: center;

  @media screen and (min-width: 1200px) {
    text-align: left;
    justify-content: left;
  }
`;
const CategoryName = styled.h1`
  margin-bottom: 3rem;
  text-align: center;
  font-size: 2.625rem;
  font-weight: 400;
  text-transform: capitalize;
  @media screen and (min-width: 1200px) {
    text-align: left;
  }
`;
class CategoryPage extends Component {
  render() {
    return (
      <Container>
        <Query
          fetchPolicy="no-cache"
          query={ProductsQuery}
          variables={{
            input: {
              title:
                Object.keys(this.props.params).length === 0
                  ? ""
                  : this.props.params.category.toLowerCase(),
            },
          }}
        >
          {({ loading, error, data }) => {
            if (loading) return <LoadingSpinner />;
            if (error) return <Error type="Server" />;
            if (data.category === null) return <Error type="Page" />;
            document.title =
              data.category.name[0].toUpperCase() + data.category.name.slice(1);
            return (
              <>
                <CategoryName>{data.category.name}</CategoryName>
                <ProductsContainer>
                  {data.category.products.map((product) => (
                    <Product key={product.id} productDetails={product} />
                  ))}
                </ProductsContainer>
              </>
            );
          }}
        </Query>
      </Container>
    );
  }
}
export default withRouter(CategoryPage);
